import { LayoutPage } from '@/components/hoc';
import { Separator } from '@/components/ui';
import { Outlet } from 'react-router-dom';
import { useTabSelected } from './hooks';
import { TabMenus } from './components';
import { Wallet } from 'lucide-react';
import routes from '@/lib/routes';

const AccountingPage = () => {
	const { title, tabSelected } = useTabSelected();

	return (
		<LayoutPage
			header={{
				description: "Gestion des opérations comptables et suivi de l’état des finances en temps réel.",
				title: 'Comptabilité'
			}}
			breadcrumb={{
				title,
				subMenus: [
					{
						href: routes.nav.accounting.overview.path,
						title: 'Comptabilité',
						menus: (
							[
								tabSelected !== 'transactions' && {
									href: routes.nav.accounting.transactions.path,
									title: `Transactions`
								},
								tabSelected !== 'overview' && {
									href: routes.nav.accounting.overview.path,
									title: `Vue d'ensemble`
								}
							] as any[]
						).filter(l => l)
					}
				]
			}}
			icon={Wallet}
		>
			<div className="flex flex-col space-y-3 ">
				<TabMenus />
				<Separator className="bg-muted" />
				<Outlet />
			</div>
		</LayoutPage>
	);
};

export default AccountingPage;
